import ChevronRight from '@simplywallst/ui-core/icons/ChevronRightSmallSolid';
import { Button } from '@simplywallst/ui-core';
import Tooltip from '@/components/Tooltip';

import { PrimaryNarrativeIcon } from './PrimaryNarrativeIcon';

type Props = {
  tickerSymbol: string;
};

export const EmptyState = ({ tickerSymbol }: Props) => {
  return (
    <div className="grid h-auto gap-2 sm:h-x12">
      <div className="grid grid-cols-[auto_auto] items-center justify-start gap-x1">
        <div className="grid grid-cols-[24px_max-content] items-center gap-2 opacity-80">
          <PrimaryNarrativeIcon type="dcf" />
          <div>
            <span className="m-0 text-xs text-soft">N/A</span>
            <span className="sr-only">author fair value</span>
          </div>
        </div>
        <div>
          <span className="text-tiny text-softer">Yesterday</span>
          <span className="sr-only">author updated this narrative</span>
        </div>
      </div>
      <div className="grid grid-cols-[auto_auto] items-start justify-between gap-x2">
        <h4 className="m-0 line-clamp-2 text-xs text-softer">
          Insufficient data to calculate {tickerSymbol}'s fair value for
          valuation analysis.
        </h4>
        <Tooltip
          placement="top-end"
          light
          title={
            <p className="text-noir m-0 line-clamp-2 w-48 text-tiny">
              You can select a narrative from community or create one yourself.
            </p>
          }
        >
          <Button styleType="gentle" alignIcon="right">
            Select
            <ChevronRight />
          </Button>
        </Tooltip>
      </div>
    </div>
  );
};
